
// import React from 'react';
// import { Link } from 'react-router-dom';
// import './PromoSidebar.css';

// import londonvoucher from './London Voucher.webp';

// export default function PromoSidebar({ offers }) {
//   const defaultOffers = [
//     { id: 1, title: '🔥 Special Winter Sale', desc: 'Get 30% off on all London packages!  *T&C Apply' , btn: 'Grab Now', images: [londonvoucher] },
//   ];

//   const displayOffers = offers || defaultOffers;

//   return (
//     <aside className="promo-sidebar">
//       <h2>Exclusive Travel Offers</h2>
//       {displayOffers.map((offer) => (
//         <div className="voucher-card" key={offer.id}>
//           {offer.images?.length > 0 && (
//             <div className="voucher-images">
//               {offer.images.map((img, idx) => (
//                 <img key={idx} src={img} alt={offer.title ? `${offer.title} ${idx + 1}` : `offer-${idx + 1}`} className="voucher-img" />
//               ))}
//             </div>
//           )}

//           {offer.title && <h3>{offer.title}</h3>}
//           {offer.desc && <p>{offer.desc}</p>}

//           {offer.btn && (
//             <Link to="/contact" className="offerbutton">
//               {offer.btn}
//             </Link>
//           )}
//         </div>
//       ))}
//     </aside>
//   );
// }

import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PromoSidebar.module.css';

import londonvoucher from './London Voucher.webp';

export default function PromoSidebar({ offers }) {
  const defaultOffers = [
    {
      id: 1,
      title: '🔥 Special Winter Sale',
      desc: 'Get 30% off on all London packages! *T&C Apply',
      btn: 'Grab Now',
      images: [londonvoucher],
    },
  ];

  const displayOffers = offers || defaultOffers;

  return (
    <aside className={styles.promoSidebar}>
      <h2>Exclusive Travel Offers</h2>
      {displayOffers.map((offer) => (
        <div className={styles.voucherCard} key={offer.id}>
          {offer.images?.length > 0 && (
            <div className={styles.voucherImages}>
              {offer.images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={
                    offer.title
                      ? `${offer.title} ${idx + 1}`
                      : `offer-${idx + 1}`
                  }
                  className={styles.voucherImg}
                />
              ))}
            </div>
          )}

          {offer.title && <h3>{offer.title}</h3>}
          {offer.desc && <p>{offer.desc}</p>}

          {offer.btn && (
            <Link to="/contact" className={styles.offerButton}>
              {offer.btn}
            </Link>
          )}
        </div>
      ))}
    </aside>
  );
}
